import type { Tool } from '@/services/tools'

/**
 * Checks if a tool is the Notion internal tool
 */
export function isNotionTool(tool: Tool): boolean {
  return (
    tool.tool_type === 'internal' &&
    (tool.name.toLowerCase() === 'notion' ||
      (tool.config as Record<string, unknown>)?.internal_name === 'notion')
  )
}
